export default "__VITE_ASSET__37ca8a57__"